import { Injectable } from '@angular/core';
import { SignatureDTO, SignatureValidationCode } from '../app/api/plyca-dtos';
import { AppConfiguration } from '../app/conf/app.configuration';
import { SignatureProvider, SignatureProviderType } from './signature/signature.objects';

const DEFAULT_PROVIDER = {
  type: SignatureProviderType.AFIRMA,
  config: {
    btnName: 'Signature.AutoFirma.Label',
    btnIcon: 'fa fa-1-25x fa-file-signature',
    btnClass: 'btn-primary  show-text-onxs'
  }
} as SignatureProvider;

@Injectable()
export class SignatureUtils {

  constructor(private appConfiguration: AppConfiguration) {
  }

  public getSignatureProviders(): SignatureProvider[] {
    return this.appConfiguration.getValue('signature.providers') as SignatureProvider[] || [DEFAULT_PROVIDER];
  }

  public getSignatureProvider(type: string): SignatureProvider {
    const sigProviders = this.getSignatureProviders();
    const selectedProvider = sigProviders.find(provider => provider.type === type);
    if (selectedProvider?.type === SignatureProviderType.AFIRMA && !selectedProvider.config) {
      selectedProvider.config = DEFAULT_PROVIDER.config;
    }
    return selectedProvider;
  }

  /**
   * Devuelve el resultado de validar la ultima firma en profundidad del arbol de firmas, si existe
   *
   * @param signatures
   */
  public getValidOrEmptySignatureCode(signatures: SignatureDTO): SignatureValidationCode {
    let validationCode: SignatureValidationCode;
    if (signatures) {
      validationCode = this.validateSignature(signatures);
    }
    return validationCode;
  }
  public getLastSignature(signatures: SignatureDTO[]): SignatureDTO {
    let lastSignature: SignatureDTO;
    let auxSignatureList = signatures;
    while (auxSignatureList && auxSignatureList.length > 0) {
      lastSignature = auxSignatureList[auxSignatureList.length - 1];
      auxSignatureList = lastSignature.signatures;
    }
    return lastSignature;
  }
  public getFirstSignatureWithVerificationEror(signatures: SignatureDTO[]): SignatureDTO {

    if (signatures) {
      for (var s of signatures) {
        if (s.verification && this.validateSignature(s) !== SignatureValidationCode.OK)
          return s;
        if (s.signatures) {
          let signature = this.getFirstSignatureWithVerificationEror(s.signatures);
          if (signature)
            return signature;
        }
      }
    }
    return null;

  }

  public validateSignature(signature: SignatureDTO): SignatureValidationCode {
    if (!signature || !signature.verification) {
      console.log('La firma no contiene datos de verificacion', signature);
      return SignatureValidationCode.ERROR_SIGNATURE;
    } else if (!signature.verification.integrityValid) {
      console.log('Error de integridad de firma');
      return SignatureValidationCode.ERROR_INTEGRITY;
    } else if (signature.verification.certificate && !signature.verification.certificate.ok
      && signature.verification.certificate.fatalError) {
      console.log('Error CA no reconocida');
      return SignatureValidationCode.ERROR_CERTIFICATE;
    } else if (signature.verification.certificate && signature.verification.certificate.revoked) {
      console.log('Error certificado revocado');
      return SignatureValidationCode.ERROR_CERTIFICATE_REVOKED;
    } else if (signature.verification.certificate && signature.verification.certificate.expiredOrNotValidYet) {
      console.log('Error certificado expirado');
      return SignatureValidationCode.ERROR_CERTIFICATE_EXPIRED;
    } else if (signature.verification.error) {
      console.log('Error de validacion');
      return SignatureValidationCode.ERROR_SIGNATURE;
    } else {
      console.log('Firma valida');
      return SignatureValidationCode.OK;
    }
  }

  public isChromeOS(): boolean {
    // Verifica si el sistema operativo es Chrome OS
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes('cros');
  }

}
